import axios from '../../config/axios.js'
import store from '../../vuex/store.js'

const STATE = {

    my_tickets: null,
    my_ticket_details: {},
    tk_id: null,

}

const GETTERS = {

    my_tickets: state => state.my_tickets,
    my_ticket_details: state => state.my_ticket_details,
    tk_id: state => state.tk_id,

}

const MUTATIONS = {

    getMyTickets(state, tickets) {
        state.my_tickets = tickets
    },

    getMyTicketDetails(state, ticket) {
        state.my_ticket_details = ticket
    },

    getMyTicketId(state, tk_id) {
        state.tk_id = tk_id
    }

}

const ACTIONS = {

    async createMyTicket({ commit, dispatch }, payload) {
        await axios.ACCESS.post('/api/myticket', payload)
            .then(res => {
                // console.log('ticket/createMyTicket', res)
                if (res.data.result) {
                    commit('getMyTicketId', res.data.ticket.tk_id)
                    dispatch('getMyTickets')
                } else { throw new Error(res.data) }
            })
    },

    async getMyTickets({ commit }) {
        await axios.ACCESS.get('/api/mytickets')
            .then(res => {
                // console.log('ticket/getMyTickets', res)
                if (res.data.result) {
                    commit('getMyTickets', res.data.tickets)
                } else { throw new Error(res.data) }
            })
    },

    async getMyTicketDetails({ commit }, tk_id) {
        await axios.ACCESS.get('/api/myticket/' + tk_id)
            .then(res => {
                // console.log('ticket/getMyTicketDetails', res)
                if (res.data.result) {
                    commit('getMyTicketDetails', res.data.ticket)
                } else { throw new Error(res.data) }
            })
    },

    async comment({ dispatch }, payload) {
        await axios.ACCESS.post('/api/myticket/' + payload.tk_id + '/comment', {
                comment: payload.comment,
                type: 0,
            })
            .then(async(res) => {
                // console.log('ticket/comment', res)
                if (res.data.result) {
                    await dispatch('changeStatus', {
                        tk_id: payload.tk_id,
                        status: 1,
                    })
                    await dispatch('getMyTicketDetails', payload.tk_id)
                } else { throw new Error(res.data) }
            })
    },

    async changeStatus({ commit }, payload) {
        await axios.ACCESS.patch('/api/myticket/' + payload.tk_id, {
                status: payload.status,
            })
            .then(res => {
                // console.log('ticket/changeStatus', res)
                if (!res.data.result) {
                    throw new Error(res.data)
                }
            })
    },

}

export default {
    namespaced: true,
    state: STATE,
    getters: GETTERS,
    mutations: MUTATIONS,
    actions: ACTIONS,
}


// WEBPACK FOOTER //
// ./src/vuex/modules/ticket.js